export default function EmptySection() {
  return <section data-section-id="88554" id="emptysection" className="bg-muted py-20 text-foreground !h-[575px] md:py-[120px] bg-cover bg-center bg-no-repeat !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/2ca665e6f04adca4b9343810717b131a1364x575.png)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          
          {}
          

        </div>
      </div>
    </section>;
}